(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambassador-section"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__ambReveal) return;
    window.__ambReveal = true;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.js-amb-reveal').forEach(function(el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c__product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function showAll(root) {
      var hidden = root.querySelectorAll('.c-reviews__item.is-hidden');
      Array.prototype.forEach.call(hidden, function (item) {
        item.classList.remove('is-hidden');
      });

      var wrap = root.querySelector('.c-reviews__more-wrap');
      if (wrap) wrap.hidden = true;
    }

    function initReviews(root) {
      if (!root || root.dataset.reviewsReady === 'true') return;
      root.dataset.reviewsReady = 'true';

      var moreButton = root.querySelector('.c-reviews__more');
      if (!moreButton) return;

      moreButton.addEventListener('click', function () {
        showAll(root);
      });
    }

    function initAll(scope) {
      var container = scope || document;
      Array.prototype.forEach.call(container.querySelectorAll('.c-reviews'), initReviews);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    // テーマエディタで隠れているレビューを選んだときは、全件開いて編集できるようにする
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest ? event.target.closest('.c-reviews') : null;
      if (root) showAll(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c__shop-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShopList(root) {
      if (!root || root.dataset.shoplistReady === 'true') return;
      root.dataset.shoplistReady = 'true';

      var buttons = root.querySelectorAll('.c-shoplist__filter-btn');
      var areas = root.querySelectorAll('.c-shoplist__area');
      var emptyMessage = root.querySelector('.c-shoplist__empty');

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          var selectedArea = button.getAttribute('data-area');
          var visibleCount = 0;

          Array.prototype.forEach.call(buttons, function (other) {
            other.classList.remove('is-active');
          });
          button.classList.add('is-active');

          Array.prototype.forEach.call(areas, function (area) {
            var isMatch = selectedArea === 'all' || area.getAttribute('data-area') === selectedArea;
            area.hidden = !isMatch;
            if (isMatch) visibleCount++;
          });

          if (emptyMessage) {
            emptyMessage.hidden = visibleCount > 0;
          }
        });
      });
    }

    function initAll(scope) {
      var container = scope || document;
      Array.prototype.forEach.call(container.querySelectorAll('.c-shoplist'), initShopList);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var video = document.getElementById('mv-video');
    var loading = document.getElementById('mv-loading');
    if (!video) return;

    var SRC_PC = 'https://cdn.shopify.com/videos/c/o/v/d8b15b4549ec410896254a7f19617d94.mp4';
    var SRC_SP = 'https://cdn.shopify.com/videos/c/o/v/b4b82a8b92484ea88dc3ebe9c5a321e9.mp4';
    var BREAKPOINT = 768;
    var currentSrc = '';

    function pickSrc() {
      return window.innerWidth > BREAKPOINT ? SRC_PC : SRC_SP;
    }

    function loadVideo() {
      var newSrc = pickSrc();
      if (newSrc === currentSrc) return;
      currentSrc = newSrc;

      video.classList.remove('is-ready');
      if (loading) loading.classList.remove('is-hidden');

      video.src = newSrc;
      video.load();
    }

    function onReady() {
      video.classList.add('is-ready');
      if (loading) loading.classList.add('is-hidden');

      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function() {
          var resume = function() {
            video.play();
            document.removeEventListener('touchstart', resume);
            document.removeEventListener('click', resume);
          };
          document.addEventListener('touchstart', resume, { once: true });
          document.addEventListener('click', resume, { once: true });
        });
      }
    }

    video.addEventListener('loadeddata', onReady);
    video.addEventListener('canplay', onReady);
    video.addEventListener('error', function() {
      if (loading) loading.classList.add('is-hidden');
    });

    loadVideo();

    var resizeTimer = null;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(loadVideo, 250);
    });

    document.addEventListener('visibilitychange', function() {
      if (!document.hidden && video.paused) {
        video.play().catch(function() {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
